



































































































































import { apiClient } from "@/services/api-client";
import { requiresAdminMixin } from "@/mixins/requiresAdminMixin";
import LoadingBlock from "@/components/LoadingBlock.vue";
import WachtwoordInput from "@/components/WachtwoordInput.vue";
import BasePage from "@/components/Base/BasePage.vue";
import BaseBreadcrumb from "@/components/Base/BaseBreadcrumb.vue";
import { i18n } from "@/plugins/i18n";

export default {
  name: "GebruikerAanmaken",
  components: {
    BaseBreadcrumb,
    BasePage,
    WachtwoordInput,
    LoadingBlock
  },
  mixins: [requiresAdminMixin],
  data() {
    return {
      username: "",
      usernameIsEmail: false,
      email: "",
      password: "",
      voornaam: "",
      achternaam: "",
      bedrijfsnaam: "",
      isLoading: false,
      isValidated: false,
      usernamePattern: null,
      promoteToAdmin: false,
      sendMail: false
    };
  },
  methods: {
    setEmail() {
      if (this.usernameIsEmail) {
        this.email = this.username;
      } else {
        this.email = "";
      }
    },
    register() {
      this.isLoading = true;

      apiClient
        .gebruikerAanmaken({
          password: this.password,
          username: this.username,
          email: this.email,
          achternaam: this.achternaam,
          voornaam: this.voornaam,
          bedrijfsnaam: this.bedrijfsnaam,
          promoteToAdmin: this.promoteToAdmin,
          language: i18n.locale,
          sendEmail: this.sendMail
        })
        .then(() => {
          this.password = "";
          this.username = "";
          this.email = "";
          this.usernameIsEmail = false;
          this.achternaam = "";
          this.voornaam = "";
          this.bedrijfsnaam = "";
          this.isValidated = false;
          this.promoteToAdmin = false;
          this.sendMail = false;

          this.$store.dispatch("snackbarAdded", {
            text: this.$t("GebruikerAanmaken.success"),
            type: "success"
          });
        })
        .catch(error => {
          if (error.status === 409) {
            // Source: https://stackoverflow.com/questions/19605150/regex-for-password-must-contain-at-least-eight-characters-at-least-one-number-a
            this.usernamePattern = `^(?!${this.username}$).*`;
            return;
          }

          this.$store.dispatch("snackbarAdded", {
            text: this.$t("error.server_fout"),
            type: "danger"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
